

export default {
	transparent: {
		border: 'none',
		backgroundColor: 'transparent'
	},
	chatSend: {
		marginTop: '4px',
		borderRadius: '5px',
		minHeight: '35px',
		maxHeight: '35px'
	},
	main: {
		boxShadow:  '0 0 6px rgba(0, 0, 0, .16)',
		width: '167px',
		height: '50px',
		overflow: 'hidden'
	},
	mainLong: {
			boxShadow:  '0 0 6px rgba(0, 0, 0, .16)',
			minWidth: '167px',
			height: '50px',
			overflow: 'hidden'

	},
	contact: {
		backgroundColor: 'white',
		border: '1px solid #2b80b9',
		color: '#2b80b9',
		width: '167px',
		height: '50px',
		overflow: 'hidden',
		boxShadow:  '0 0 6px rgba(0, 0, 0, .16)'
	},
	remove: {
		backgroundColor: 'white',
		border: '1px solid #F95050',
		color: '#F95050',
		width: '167px',
		height: '50px',
		overflow: 'hidden',
		boxShadow:  '0 0 6px rgba(0, 0, 0, .16)'
	},
	approve: {
		// backgroundColor: '#2b80b9',
		width: '135px',
		height: '47px',
		overflow: 'hidden'
	},
	save: {
		// backgroundColor: '#2b80b9',
		width: '160px',
		height: '47px',
		overflow: 'hidden'
	},
	signout: {
		// backgroundColor: '#2b80b9',
		width: '240px',
		height: '47px',
		overflow: 'hidden'
	},
	secondary: {
		backgroundColor: '#ab80b9',
		width: '132',
		height: '47px',
		overflow: 'hidden'
	},
	second: {
		height: '30px',

		verticalAlign: 'center',
		alignItems: 'center',
		boxShadow: '0 0 6px rgba(0, 0, 0, .16)'

	},
	floating: {
		borderRadius: '25px',
	},
	checkin: {
		boxShadow: '0 0 6px rgba(0, 0, 0, .16)'
	},
	pwReset: {
		minWidth: '250px',
		height: '50px'

	}
}